/**
 * Blog Related Posts — Load More
 * Carrega mais posts via AJAX ao clicar no botão.
 *
 * A cada clique enviamos os IDs de todos os posts já visíveis (data-post-id dos
 * cards + os IDs exibidos em outras seções, via data-excluded). O backend usa
 * post__not_in em vez de paginação por offset — offset repetia conteúdo porque
 * em admin-ajax o WP_Query também conta rascunhos e agendados.
 */

export function initBlogRelatedLoadMore() {
	const btn = document.querySelector( '.blog-related__btn' );
	if ( ! btn ) return;

	const grid = document.querySelector( '.blog-related__grid' );
	if ( ! grid ) return;

	const article   = document.querySelector( '.blog-single[data-post-id]' );
	const currentId = parseInt( article ? article.dataset.postId : 0, 10 ) || 0;

	// IDs já exibidos fora deste grid (destaque, grid da home etc.)
	const serverExcluded = ( btn.dataset.excluded || '' )
		.split( ',' )
		.map( ( id ) => parseInt( id, 10 ) )
		.filter( Boolean );

	const layout = btn.dataset.layout || 'overlay';

	const collectExcluded = () => {
		const visible = Array.from( document.querySelectorAll( '[data-post-id]' ) )
			.map( ( el ) => parseInt( el.dataset.postId, 10 ) )
			.filter( Boolean );

		return Array.from( new Set( [ ...serverExcluded, ...visible ] ) ).join( ',' );
	};

	btn.addEventListener( 'click', async ( e ) => {
		e.preventDefault();

		btn.textContent = 'Carregando...';
		btn.style.pointerEvents = 'none';
		btn.style.opacity = '0.6';

		try {
			const formData = new FormData();
			formData.append( 'action', 'rb_load_more_related' );
			formData.append( 'current_id', currentId );
			formData.append( 'excluded_ids', collectExcluded() );
			formData.append( 'layout', layout );
			formData.append( 'nonce', rbAjax.nonce );

			const response = await fetch( rbAjax.url, {
				method: 'POST',
				body: formData,
			} );

			const data = await response.json();

			if ( data.success && data.data.html ) {
				grid.insertAdjacentHTML( 'beforeend', data.data.html );

				if ( ! data.data.has_more ) {
					btn.textContent = 'Não há mais conteúdos';
					btn.style.pointerEvents = 'none';
					btn.style.opacity = '0.4';
				} else {
					btn.textContent = 'Carregar mais conteúdos';
					btn.style.pointerEvents = '';
					btn.style.opacity = '';
				}
			} else {
				btn.textContent = 'Não há mais conteúdos';
				btn.style.pointerEvents = 'none';
				btn.style.opacity = '0.4';
			}
		} catch ( err ) {
			btn.textContent = 'Erro ao carregar';
			btn.style.pointerEvents = 'none';
			btn.style.opacity = '0.4';
		}
	} );
}
